import { render, staticRenderFns } from "./MetricAnalyticsCard.vue?vue&type=template&id=480ede3f&scoped=true"
import script from "./MetricAnalyticsCard.vue?vue&type=script&lang=ts"
export * from "./MetricAnalyticsCard.vue?vue&type=script&lang=ts"
import style0 from "./MetricAnalyticsCard.vue?vue&type=style&index=0&id=480ede3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ede3f",
  null
  
)

export default component.exports